import { ca } from '@cian/analytics';
import { IJsonQuery } from '../../../../json_query';

export const nothingFoundTracking = {
  trackShow(searchConditions: IJsonQuery) {
    ca('eventSite', {
      name: 'oldevent',
      category: 'subscription',
      action: 'Show',
      label: 'From_Empty',
      searchConditions,
    });
  },

  trackSubscribeWithNews() {
    ca('event', {
      name: 'oldevent',
      category: 'subscription',
      action: 'Send',
      label: 'news_From_Empty',
    });
  },

  trackSubscribeWithRegistrate() {
    ca('event', {
      name: 'oldevent',
      category: 'Registration',
      action: 'subscription',
      label: 'From_Empty',
    });
  },
};

export const listTracking = {
  trackShow(searchConditions: IJsonQuery) {
    ca('eventSite', {
      name: 'oldevent',
      category: 'subscription',
      action: 'Show',
      label: 'From_cat_long',
      searchConditions,
    });
  },

  trackSubscribeWithNews() {
    ca('event', {
      name: 'oldevent',
      category: 'subscription',
      action: 'Send',
      label: 'news_From_cat_long',
    });
  },

  trackSubscribeWithRegistrate() {
    ca('event', {
      name: 'oldevent',
      category: 'Registration',
      action: 'subscription',
      label: 'From_cat_long',
    });
  },
};
